import * as React from "react";
import { SuperPage } from "@/services/bedrock";
import { Badge, Card, Progress } from "@/components/ui";
import { Eye, MousePointerClick } from "lucide-react";
import { URLS } from "@/utils";
import { Link } from "react-router-dom";
import { SuperPageTabs } from ".";

type Props = {
  superPage: SuperPage;
  disabled: boolean;
};

const SuperPageCard: React.FC<Props> = ({ superPage, disabled }) => {
  const superPageUrl = URLS.coach.superPage.replace(":id", superPage.id.toString());
  const performanceUrl = `${superPageUrl}?tab=${SuperPageTabs.PerformanceRoster.value}`;

  return (
    <Link to={superPageUrl} className={disabled ? "pointer-events-none" : "block h-full"}>
      <Card disabled={disabled} className="w-full h-full cursor-pointer hover:shadow-md justify-between">
        <Card.Header>
          <Card.Title className="font-semibold">{superPage.title || <i>No title</i>}</Card.Title>
          <Card.Description className="text-sm text-muted-foreground">
            <div className="flex flex-wrap items-center gap-1">
              {superPage.categories?.map(category => (
                <Badge key={`category-${category.id}`} className={"whitespace-nowrap"} size="small" variant="outline">
                  {category.name}
                </Badge>
              ))}
            </div>
          </Card.Description>
          <Card.Action>
            <Badge
              size="small"
              variant="outline-label"
              className={superPage.status == "DRAFT" ? "text-slate-400" : "text-primary"}
            >
              {superPage.status == "DRAFT" ? "Draft" : "Live"}
            </Badge>
          </Card.Action>
        </Card.Header>
        <Card.Content className="flex flex-col gap-4">
          <div className="flex items-center gap-2">
            <Link to={performanceUrl} onClick={e => e.stopPropagation()}>
              <Badge variant="label" className="hover:shadow-md">
                <div className="flex items-center gap-2 text-xs/3 py-1">
                  <Eye className="size-4" />
                  <div>{superPage.totalViews ?? 0}</div>
                </div>
              </Badge>
            </Link>

            <Link to={performanceUrl} onClick={e => e.stopPropagation()}>
              <Badge variant="label" className="hover:shadow-md">
                <div className="flex items-center gap-2 text-xs/3 py-1">
                  <MousePointerClick className="size-4" />
                  <div>{superPage.totalClicks ?? 0}</div>
                </div>
              </Badge>
            </Link>
          </div>
          {superPage.assignmentsOverview && (
            <Progress
              value={
                superPage.assignmentsOverview.total > 0
                  ? (superPage.assignmentsOverview.totalCompleted / superPage.assignmentsOverview.total) * 100
                  : 0
              }
              className="w-full max-w-sm"
            >
              <Progress.Label>
                {superPage.assignmentsOverview.totalCompleted}/{superPage.assignmentsOverview.total} Completed
              </Progress.Label>
            </Progress>
          )}
        </Card.Content>
      </Card>
    </Link>
  );
};

export { SuperPageCard };
